import { AuditAction } from './types';

export const AuditActionLabelMap: Record<AuditAction, string> = {
  [AuditAction.LOGIN]: 'Signed in',
  [AuditAction.USER_INVITED]: 'Invited a user',
  [AuditAction.CONTENT_CREATED]: 'Created onboarding screen',
  [AuditAction.CONTENT_EDITED]: 'Edited onboarding screen',
  [AuditAction.CONTENT_PUBLISHED]: 'Published onboarding screen',
  [AuditAction.CONTENT_UNPUBLISHED]: 'Unpublished onboarding screen',
};
